/**
 * Navigation
 *
 * Customizes the WordPress core navigation block's mobile overlay:
 *
 * 1. Moves the mobile drawer (CTA, phone, search) into the overlay's
 *    content container so it lives inside the focus-trapped dialog.
 * 2. Lets the hamburger button toggle close while the overlay is open
 *    (the core block's button only opens; we intercept and forward the
 *    click to the hidden close button).
 */

document.addEventListener( 'DOMContentLoaded', () => {
	const drawer = document.querySelector( '.site-header__mobile-drawer' );
	const overlayContent = document.querySelector(
		'.site-header__navigation .wp-block-navigation__responsive-container-content'
	);

	if ( drawer && overlayContent ) {
		overlayContent.appendChild( drawer );
	}

	// Inject a real <button> as a sibling of each parent link, so taps
	// on the chevron toggle the submenu instead of falling through to
	// the link. The parent link still navigates to its own page.
	const submenuParents = document.querySelectorAll(
		'.site-header__navigation .wp-block-navigation-item.has-child'
	);
	submenuParents.forEach( ( parent ) => {
		if ( parent.querySelector( ':scope > .site-header__submenu-toggle' ) ) {
			return;
		}

		const link = parent.querySelector(
			':scope > .wp-block-navigation-item__content'
		);
		if ( ! link ) {
			return;
		}

		const toggle = document.createElement( 'button' );
		toggle.type = 'button';
		toggle.className = 'site-header__submenu-toggle';
		toggle.setAttribute( 'aria-label', 'Toggle submenu' );
		toggle.setAttribute( 'aria-expanded', 'false' );

		toggle.addEventListener( 'click', ( event ) => {
			event.preventDefault();
			event.stopPropagation();
			const isOpen = parent.classList.toggle( 'is-submenu-open' );
			toggle.setAttribute( 'aria-expanded', isOpen ? 'true' : 'false' );
		} );

		link.insertAdjacentElement( 'afterend', toggle );
	} );
} );

// Capture-phase listener so it runs before the core block's bubble-phase
// Interactivity API click handler. When the menu is already open, we
// short-circuit and trigger the hidden close button instead of opening.
document.addEventListener(
	'click',
	( event ) => {
		const openBtn = event.target.closest(
			'.site-header__navigation .wp-block-navigation__responsive-container-open'
		);
		if ( ! openBtn ) {
			return;
		}
		if ( ! document.documentElement.classList.contains( 'has-modal-open' ) ) {
			return;
		}

		event.preventDefault();
		event.stopImmediatePropagation();

		const closeBtn = document.querySelector(
			'.site-header__navigation .wp-block-navigation__responsive-container-close'
		);
		if ( closeBtn ) {
			closeBtn.click();
		}
	},
	true
);

// Dropdown auto-alignment.
//
// The desktop submenu panel is left-aligned to its parent <li> by
// default. For nav items sitting near the right edge of the viewport
// that can push the panel off-screen. This precomputes — on load and
// resize — whether each parent's panel would overflow and toggles a
// `submenu-align-right` class that the CSS uses to flip the panel to
// right-aligned (right: 0; left: auto).
//
// Width is the CSS min-width (310px) plus a small viewport buffer.
const DROPDOWN_WIDTH = 310;
const VIEWPORT_BUFFER = 16;

function alignNavDropdowns() {
	const items = document.querySelectorAll(
		'.site-header__navigation .wp-block-navigation__container > .wp-block-navigation-item.has-child'
	);
	if ( ! items.length ) {
		return;
	}

	const viewportWidth = document.documentElement.clientWidth;

	items.forEach( ( item ) => {
		const rect = item.getBoundingClientRect();
		const overflowsRight =
			rect.left + DROPDOWN_WIDTH + VIEWPORT_BUFFER > viewportWidth;
		item.classList.toggle( 'submenu-align-right', overflowsRight );
	} );
}

let alignTimer;
function scheduleAlign() {
	clearTimeout( alignTimer );
	alignTimer = setTimeout( alignNavDropdowns, 100 );
}

document.addEventListener( 'DOMContentLoaded', alignNavDropdowns );
// Re-run after the load event in case web fonts shift item positions.
window.addEventListener( 'load', alignNavDropdowns );
window.addEventListener( 'resize', scheduleAlign );
